import React from 'react';
import Tile from '../../../common/components/Tile/Tile';
import { List as ListIcon } from '@mui/icons-material';
import { ListItem, TextField, Button } from '@mui/material';
import TableEnhancedContainer from '../../../common/components/TableEnhanced/TableEnhancedContainer';

const CommandJobCreator = (props) => (
  <div>
    <Tile
      TitleIcon={ListIcon}
      title={'Package selection'}
      helpTag="command_job_creator_package_selection"
    >
      <TextField
        variant="standard"
        select={true}
        label="Select package"
        value={props.selectedPackageId}
        onChange={(event) => {
          props.onSelectPackage(event.target.value);
        }}
        style={{ width: '30%' }}
        data-qa="qa-selectPackage"
      >
        {props.availablePackages.map((availablePackage) => (
          <ListItem button key={availablePackage.PackageId} value={availablePackage.PackageId}>
            {availablePackage.Name}
          </ListItem>
        ))}
      </TextField>
    </Tile>
    <div className="u-mt-full">
      <Tile
        TitleIcon={ListIcon}
        title={'Destination selection'}
        helpTag="command_job_creator_fleet_selection"
      >
        <TextField
          variant="standard"
          select={true}
          label="Select destination"
          value={props.selectedFleetId}
          onChange={(event) => {
            props.onSelectFleet(event.target.value);
          }}
          style={{ width: '30%' }}
          data-qa="qa-selectFleet"
        >
          {props.fleets.map((fleet) => (
            <ListItem button key={fleet.FleetId} value={fleet.FleetId}>
              {fleet.Name}
            </ListItem>
          ))}
        </TextField>
        <Button
          variant="contained"
          data-qa="qa-startCommandJob"
          className="u-ml-double"
          color="primary"
          disabled={props.startCommandJobDisabled}
          onClick={() => props.startCommandJob()}
        >
          START COMMAND JOB
        </Button>
        <div className="u-mt-double">
          <TableEnhancedContainer
            {...props}
            className="CommandJobTable"
            enableHideColumns={true}
            enableActionButtons={true}
          />
        </div>
      </Tile>
    </div>
  </div>
);

export default CommandJobCreator;
